import script from "./TableroProgramasView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableroProgramasView.vue?vue&type=script&setup=true&lang=ts"

import "./TableroProgramasView.vue?vue&type=style&index=0&id=5d6537f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6537f0"]])

export default __exports__